var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPaymentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "payment-upaid-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Credit_Card_Line",
    "data-name": "icons/Credit Card/Line",
    transform: "translate(1.602 3.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M17.959,1.89H2.836a.945.945,0,0,0-.945.945V14.178a.945.945,0,0,0,.945.945H17.959a.945.945,0,0,0,.945-.945V2.836A.945.945,0,0,0,17.959,1.89ZM2.836,0A2.836,2.836,0,0,0,0,2.836V14.178a2.836,2.836,0,0,0,2.836,2.836H17.959a2.836,2.836,0,0,0,2.836-2.836V2.836A2.836,2.836,0,0,0,17.959,0Z",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M2.836,1.418A1.418,1.418,0,1,1,1.418,0,1.418,1.418,0,0,1,2.836,1.418Z",
    transform: "translate(3.781 10.397)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M2.836,1.418A1.418,1.418,0,1,1,1.418,0,1.418,1.418,0,0,1,2.836,1.418Z",
    transform: "translate(8.507 10.397)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M0,0H20.794V1.89H0Z",
    transform: "translate(0 4.726)",
    fill: "#6b6b95"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPaymentsIcon);
export default __webpack_public_path__ + "static/media/menuPaymentsIcon.687ee60ba0ee11919bff0d081f6a281f.svg";
export { ForwardRef as ReactComponent };